import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { default as swal } from "sweetalert2";

@Component({
  selector: "app-category",
  templateUrl: "./category.component.html",
  styleUrls: ["./category.component.css"],
})
export class CategoryComponent implements OnInit {
  public href: string = "";
  public add_category = false;
  public list_category = false;

  categoryForm;
  projects;
  categories;
  submitted;

  project_id;

  projectselected;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public authService: AuthService
  ) {
    /* this.add_category = false;
    this.list_category = false; */
  }

  ngOnInit() {
    this.href = this.router.url;
    console.log(this.router.url);
    if (this.href == "/category/add") {
      this.add_category = true;
      this.list_category = false;
    } else {
      this.add_category = false;
      this.list_category = true;
      this.listCategory();
    }

    this.submitted = false;
    this.categoryForm = this.fb.group({
      cat_name: this.fb.control("", Validators.required),
      project_id: this.fb.control("", Validators.required),
      cat_desc: this.fb.control("", Validators.required),
      cat_status: this.fb.control("", Validators.required),
    });
    
    this.getProjects();
  }

  addCategory(args = {}) {
    this.authService.addCategory(this.categoryForm.value).subscribe((data: any) => {
      if (data.error) {
        swal("Oops!", data.message, "error");
      } else {
        swal("Success", data.message, "success");
        this.router.navigate(['./category']);
      }
    });
  }

  listCategory() {
    let args = {};

    if(this.project_id){
      args["project"] = this.project_id;
    }

    console.log("=============this===args===")
    console.log(args);

    this.authService.listCategory(args).subscribe((data: any) => {
      if (data.error) {
        //swal("OOPs!", data.message, "error");
        console.log("===error==");
        console.log(data);
      } else {
        //swal("Success", data.message, "success");
        //this.router.navigate(['./category']);
        this.categories = data.data;       
      }
    });
  }

  getProjects(args = {}) {
    this.authService.getProjects(args).subscribe((data: any) => {
      if (data.error) {
        //swal("OOPs!", data.message, "error");
        console.log("===no data found");
      } else {
        this.projects = data.data;        
       
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/category/category.component.ts